module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "salary-rules__rule-container"
  }, [_c('div', {
    staticClass: "d-input-group--toggler",
    class: {
      'd-input-group--toggler--active': _vm.isOn
    },
    on: {
      "click": _vm.setIsOn
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("\n      Skal vikaren have ekstra løn før første lektion?\n    ")]), _vm._v(" "), _c('AppToggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.isOn
    }
  })], 1), _vm._v(" "), (_vm.isOn) ? _c('div', {
    staticClass: "d-groups"
  }, [_vm._l((_vm.atStartOfDay), function(timeItem, index) {
    return _c('div', {
      key: index,
      staticClass: "d-groups__group"
    }, [_c('span', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: false,
          placement: 'right'
        }),
        expression: "{\n                  arrow: false,\n                  placement : 'right'\n                }"
      }],
      staticClass: "icon__bg-circle icon__bg-circle--danger d-groups__group__delete-item",
      attrs: {
        "content": 'Slet dette starttidspunkt'
      },
      on: {
        "click": function($event) {
          return _vm.deleteItem(index)
        }
      }
    }, [_c('span', {
      staticClass: "icon-bin"
    })]), _vm._v(" "), _c('div', {
      staticClass: "d-group"
    }, [_c('label', {
      staticClass: "d-label"
    }, [_vm._v("Angiv tidspunkt for første lektion")]), _vm._v(" "), _c('input', {
      staticClass: "d-input",
      attrs: {
        "type": "time"
      },
      domProps: {
        "value": timeItem.time
      },
      on: {
        "input": function($event) {
          return _vm.updateTime($event, index)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "d-group"
    }, [_c('label', {
      staticClass: "d-label"
    }, [_vm._v("Hvor mange minutter skal vikaren have ekstra?")]), _vm._v(" "), _c('input', {
      staticClass: "d-input",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": timeItem.minutes
      },
      on: {
        "input": function($event) {
          return _vm.updateMinutes($event, index)
        }
      }
    })])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-trans",
    on: {
      "click": _vm.addTime
    }
  }, [_vm._v("+ Tilføj starttidspunkt")])], 2) : _vm._e(), _vm._v(" "), (_vm.isOn) ? _c('SalaryRulesRule', {
    attrs: {
      "subjectType": _vm.subjectType,
      "propSelectedEmploymentTypeId": _vm.selectedEmploymentTitle
    },
    on: {
      "change": _vm.setRuleEmployment
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isChangesMade) ? _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')))])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c00cd10a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SalarySettingsRules/SalaryRule4.vue
// module id = 1806
// module chunks = 1